import 'bootstrap/dist/css/bootstrap.min.css';
import { motion } from 'framer-motion';

const objectives = [
  {
    no: '01', icon: '🖥️',
    title: 'डिजिटल जनगणना',
    desc: 'भारतवर्षीय जैन समाज की वास्तविक डिजिटल परिवार एवं सदस्यों का डाटाबेस तैयार करना और प्रत्येक परिवार व सदस्य की एक यूनिक आईडी प्रदान करना।',
  },
  {
    no: '02', icon: '📊',
    title: 'समाज का सटीक आंकलन',
    desc: 'जैन समाज की वास्तविक जनसंख्या, परिवारों की संख्या, आयु-वर्ग, शिक्षा एवं पेशे की सही जानकारी प्राप्त करना।',
  },
  {
    no: '03', icon: '📋',
    title: 'योजना एवं नीति निर्माण में सहायता',
    desc: 'समाज के विकास, कल्याण योजनाओं, छात्रवृत्ति, चिकित्सा सहायता और रोजगार योजनाओं को बेहतर ढंग से लागू करना।',
  },
  {
    no: '04', icon: '🤝',
    title: 'वृद्ध, असहाय एवं जरूरतमंदों की पहचान',
    desc: 'वृद्धजन, विधवा, आर्थिक रूप से कमजोर परिवारों की पहचान कर उन्हें समय पर सहायता देना।',
  },
  {
    no: '05', icon: '🎓',
    title: 'शिक्षा व युवाओं के विकास हेतु संपर्क',
    desc: 'विद्यार्थियों, युवाओं की शिक्षा, कौशल विकास, करियर मार्गदर्शन और रोजगार अवसरों की योजना बनाना।',
  },
  {
    no: '06', icon: '👩👧',
    title: 'महिलाओं एवं बाल विकास',
    desc: 'महिलाओं और बच्चों से जुड़ी आवश्यकताओं, सुरक्षा, स्वास्थ्य और सशक्तिकरण कार्यक्रमों को प्रभावी बनाना।',
  },
  {
    no: '07', icon: '🕌',
    title: 'जैन संस्थाओं, संगठन, कमेटी व तीर्थों को सशक्त करना',
    desc: 'मंदिरों, तीर्थों, शिक्षण संस्थाओं, ट्रस्टों, मंडलों, मिलन की आवश्यकताओं का आंकलन कर उन्हें सहयोग एवं डिजिटल स्तर प्रदान करना।',
  },
  {
    no: '08', icon: '🤜🤛',
    title: 'समाज की एकता एवं संगठन को मजबूत करना',
    desc: 'समाज को संगठित कर आपसी संपर्क, सहयोग और संवाद को सशक्त बनाना।',
  },
  {
    no: '09', icon: '🆘',
    title: 'आपदा एवं आपातकालीन सहायता',
    desc: 'प्राकृतिक आपदा या संकट की स्थिति में समाज के सदस्यों तक शीघ्र सहायता पहुँचाना।',
  },
  {
    no: '10', icon: '🪔',
    title: 'संस्कृति, परंपरा व संस्कारों का संरक्षण',
    desc: 'जैन धर्म, संस्कृति, परंपराओं और मूल्यों को अगली पीढ़ी तक सुरक्षित पहुँचाना।',
  },
  {
    no: '11', icon: '🗄️',
    title: 'डिजिटल डाटाबेस का निर्माण',
    desc: 'यूनिक ID के माध्यम से सुरक्षित, पारदर्शी और उपयोगी सामाजिक डाटाबेस तैयार करना।',
  },
];

const Uddeshya = () => (
  <div style={{ background: '#f8fafc', minHeight: '100vh' }}>

    {/* Hero Banner */}
    <div style={{ background: 'linear-gradient(135deg,#213F6D 0%,#213F6D 100%)', padding: 'clamp(48px,8vw,80px) 0 clamp(40px,6vw,64px)' }}>
      <div className="container text-center text-white">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <span className="badge mb-3 px-4 py-2" style={{ background: 'rgba(255,255,255,0.18)', border: '1px solid rgba(255,255,255,0.35)', borderRadius: 50, fontSize: 13, letterSpacing: 1 }}>
            🎯 उद्देश्य
          </span>
          <h1 className="fw-bold mb-3" style={{ fontSize: 'clamp(1.6rem,4vw,2.6rem)', lineHeight: 1.25 }}>
            जैन समग्र — उद्देश्य एवं लक्ष्य
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.82)', fontSize: 'clamp(0.95rem,2vw,1.1rem)', maxWidth: 620, margin: '0 auto' }}>
            जैन समाज को डिजिटल रूप से सशक्त बनाने की दिशा में एक सुनिश्चित कदम
          </p>
        </motion.div>
      </div>
    </div>

    <div className="container py-5">

      {/* What is Jain Samagra */}
      <motion.div
        className="row justify-content-center mb-5"
        initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
      >
        <div className="col-lg-10">
          <div className="rounded-4 p-4 p-md-5" style={{ background: 'linear-gradient(135deg,#f0fdfa,#e6fffa)', border: '1.5px solid #99f6e4' }}>
            <div className="d-flex align-items-center gap-3 mb-4">
              <div style={{ width: 52, height: 52, background: '#213F6D', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '1.5rem' }}>
                🏛️
              </div>
              <h2 className="fw-bold mb-0" style={{ color: '#213F6D', fontSize: 'clamp(1.2rem,3vw,1.6rem)' }}>
                जैन समग्र क्या है?
              </h2>
            </div>
            <p style={{ color: '#334155', fontSize: 'clamp(0.95rem,2vw,1.08rem)', lineHeight: 1.9, marginBottom: 0 }}>
              जैन समग्र जनगणना के अंतर्गत जैन समाज के प्रत्येक <strong>परिवार, सदस्य, संस्था एवं तीर्थ</strong> की प्रामाणिक जानकारी एकत्र कर एक सुरक्षित डिजिटल डाटाबेस तैयार किया जाता है। उसका उपयोग सामाजिक एवं धार्मिक स्तर पर समाज हित की सेवाओं में लगाने से है।
            </p>
          </div>
        </div>
      </motion.div>

      {/* Objectives Heading */}
      <div className="text-center mb-5">
        <span className="badge px-4 py-2 mb-3" style={{ background: '#0D9488', color: 'white', borderRadius: 50, fontSize: 13 }}>
          🎯 उद्देश्य
        </span>
        <h2 className="fw-bold" style={{ color: '#1E293B', fontSize: 'clamp(1.3rem,3vw,1.9rem)' }}>
          जैन समाज की जनगणना करने के उद्देश्य
        </h2>
        <p className="text-muted mt-2" style={{ fontSize: '0.95rem' }}>
          समाज के सर्वांगीण विकास हेतु निर्धारित लक्ष्य
        </p>
      </div>

      {/* Objectives Grid */}
      <div className="row g-4">
        {objectives.map((item, i) => (
          <div className="col-md-6 col-lg-4" key={i}>
            <motion.div
              className="h-100 p-4 rounded-4 bg-white"
              style={{ border: '1.5px solid #e2e8f0', boxShadow: '0 2px 12px rgba(13,148,136,0.07)', transition: 'all 0.3s' }}
              whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(13,148,136,0.15)' }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
            >
              <div className="d-flex align-items-center gap-3 mb-3">
                <div style={{ minWidth: 48, height: 48, background: '#f0fdfa', border: '1.5px solid #99f6e4', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem' }}>
                  {item.icon}
                </div>
                <div>
                  <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#0D9488', letterSpacing: '1.5px', textTransform: 'uppercase' }}>{item.no}</div>
                  <h6 className="fw-bold mb-0" style={{ color: '#1e293b', fontSize: 'clamp(0.88rem,2vw,0.98rem)', lineHeight: 1.35 }}>{item.title}</h6>
                </div>
              </div>
              <p style={{ color: '#64748b', fontSize: '0.88rem', lineHeight: 1.75, marginBottom: 0 }}>{item.desc}</p>
            </motion.div>
          </div>
        ))}
      </div>

    </div>
  </div>
);

export default Uddeshya;
